<template>
  <div>
    <div v-if="show">
      <v-col cols="12">
        <v-row class="justify-center">
          <v-form ref="form" v-model="formValid">
            <v-card
              max-width="400"
              min-width="300"
              elevation="0"
              class="my-4"
            >
              <v-card-title class="primary--text" primary-title>
                LOGIN
              </v-card-title>
              <v-col>
                <v-text-field
                  dense
                  rounded
                  filled
                  hide-details="auto"
                  email
                  :rules="ruleEmail"
                  v-model="email"
                  label="Email"
                  class="secondary mb-4"
                  @input="validateField('email')"
                ></v-text-field>
                <v-text-field
                  dense
                  rounded
                  filled
                  hide-details="auto"
                  type="password"
                  :rules="rulePass"
                  v-model="pass"
                  label="Senha"
                  class="secondary mb-4"
                  @input="validateField('pass')"
                ></v-text-field>
                <v-row class="justify-center my-2">
                  <v-btn
                    :disabled="disabled"
                    :loading="logging"
                    color="accent"
                    @click="entrarEmailPass()"
                    >Entrar</v-btn
                  >
                </v-row>
                <v-row class="justify-center">
                  <v-btn
                    router
                    text
                    class="mb-2"
                    color="success"
                    style="font-size: 8pt"
                    to="/newuser"
                  >
                    <span class="primary--text">criar uma nova conta</span>
                  </v-btn>
                </v-row>
              </v-col>
            </v-card>
          </v-form>
        </v-row>
        <v-row class="justify-center my-1">
          <span style="font-size: 9pt" class="success--text">
            ou acesse com sua conta do Google</span
          >
        </v-row>
        <v-row class="justify-center mb-5">
          <v-btn
            :disabled="disabledG"
            :loading="logging"
            small
            rounded
            outlined
            width="220"
            color="success"
            class="btn-pulsar"
            @click="entrar()"
          >
            <v-avatar size="20" color="transparent" class="mr-2">
              <img src="../assets/Google.png" title="Google" />
            </v-avatar>
            entrar com Gmail
          </v-btn>
        </v-row>
        <v-row class="justify-center my-2">
          <v-spacer></v-spacer>
          <router-link
            style="font-size: 8pt"
            to="/privacidade"
            color="primary"
            >Política Privacidade</router-link
          >
          <v-spacer></v-spacer>
          <router-link
            style="font-size: 8pt"
            to="/termosdeuso"
            color="primary"
            >Termos</router-link
          >
          <v-spacer></v-spacer>
        </v-row>

        <v-snackbar v-model="alert" multi-line color="accent" :timeout="2000">
          {{ msg }}
          <template v-slot:action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="alert = false">
              X
            </v-btn>
          </template>
        </v-snackbar>
      </v-col>
    </div>
    <div v-else>
      <v-row style="height: 80vh" class="justify-center align-center">
        <v-progress-circular
          :size="60"
          :width="8"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login-page",
  computed: {
    error() {
      return this.$store.getters.error;
    },
    logado() {
      return this.$store.getters.logado;
    },
    user() {
      return this.$store.getters.user;
    },
    autorizados() {
      return this.$store.getters.autorizados;
    },
  },
  watch: {
    logado(l) {
      if (l) {
        if (this.$route.path !== "/") {
          this.$router.push("/");
        }
      }
    },
    error(e) {
      console.log(e);
      this.showAlert();
    },
  },
  created() {

  },
  mounted() {
    if (
      this.logado === undefined ||
      Object.keys(this.logado).length === 0
    ) {
      this.$store.dispatch("onChanged").then((res) => {
      if (res) {
        if (this.$route.path !== "/") {
          this.$router.push("/");
        }
      }
      })
    }
  },
  data() {
    return {
      show: true,
      hoje: new Date().toLocaleDateString("pt-BR"),
      disabled: true,
      disabledG: false,
      logging: false,
      email: "",
      pass: "",
      msg: "",
      alert: false,
      formValid: false,
      rulePass: [
        (value) => !!value || "Obrigatório.",
        (value) => value.length >= 6 || "Mín. 6 caracteres",
      ],
      ruleEmail: [
        (value) => !!value || "Obrigatório.",
        (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "E-mail inválido";
        },
      ],
    };
  },
  methods: {
    entrar() {
      this.disabledG = true;
      this.logging = true;
      this.msg = "";
      this.$store.dispatch("login").then((res) => {
        console.log(!!res)
        if (this.error) {
          this.showAlert();
        }
      })
    },
    entrarEmailPass() {
      if (!this.pass || !this.email) {
        return;
      }
      this.disabled = true;
      this.logging = true;
      this.msg = "";
      const obj = { email: this.email, pass: this.pass };
      this.$store.dispatch("loginEmailPass", obj).then((res) => {
        console.log(!!res)
        if (this.error) {
          this.showAlert();
        }
      })
    },
    validateField() {
      const valid = this.$refs.form.validate();
      if (valid) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    showAlert() {
      this.logging = false;
      this.disabled = false;
      this.disabledG = false;
      if (this.error === "auth/invalid-credential") {
        this.msg =
          "Não foi possível entrar! Verifique sua conexão. Caso seja seu primeiro acesso clique em CRIAR CONTA ou entre com uma conta GMAIL.";
        this.alert = true;
      } else {
        this.msg =
          "Alguma coisa deu errado! Verifique seus dados e sua conexão.";
        this.alert = true;
      }
    },
  },
};
</script>

<style scoped>
@keyframes pulsar {
  0% {
    transform: scale(1);
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  }
}

.btn-pulsar {
  animation: pulsar 1s infinite;
}
</style>